import { getLocale } from "../runtime";

const sv_allbrandsdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Utforska alla varumärken som finns tillgängliga på Happy Green`
};

const allbrandsdescription = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_allbrandsdescription(inputs)
	return "allBrandsDescription";
};

export { allbrandsdescription as "allBrandsDescription" };